import React, { useState } from "react";
import { FormRenderer } from "./form-renderer";
import { ChevronDown } from "lucide-react"; // Make sure lucide-react is installed
import { cn } from "../../../lib/utils";

const FormContainer = ({
  sectionTitle = "Address Information",
  subtitle = null,
  headerTitle,
  readOnly,
  fields,
  values,
  onFieldChange,
  onFieldBlur,
  fieldValues,
  currentPiiInfoFields,
  handleFieldLevelHandler,
  componentContext = {},
  customClasses = {},
  children,
  actionButtons = null,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const supplementAddressData = {
    city: values?.city,
    state: values?.state,
    zipCode: values?.zipCode,
    countyName: values?.countyName,
  };
  return (
    <div
      className={`
        rounded-3xl border border-gray-200 bg-white
        ${customClasses?.formContainer || ""}
      `}
    >
      {sectionTitle && (
        <div
          className={cn(
            `bg-[#E8E2D8] px-6 py-4 border-b border-gray-200 rounded-t-3xl ${!isOpen && "rounded-b-3xl sm:rounded-b-none"}   cursor-pointer`,
            "flex items-center justify-between",
            customClasses?.formHeader || "",
          )}
        >
          <div>
            <div
              className={`
                text-md sm:text-lg font-semibold text-gray-800 
                ${customClasses?.formTitle || ""}
              `}
            >
              {sectionTitle}
            </div>
            {subtitle && (
              <div
                className={`
                  text-sm text-gray-600 mt-1
                  ${customClasses?.formSubtitle || ""}
                `}
              >
                {subtitle}
              </div>
            )}
          </div>

          <div className="flex items-center gap-2">
            {actionButtons && <>{actionButtons}</>}
            <ChevronDown
              onClick={() => setIsOpen(!isOpen)}
              className={cn(
                "sm:hidden transition-transform duration-300",
                isOpen ? "rotate-180" : "rotate-0",
              )}
              size={20}
            />
          </div>
        </div>
      )}

      <div
        className={`p-4 ${isOpen ? "block" : "hidden sm:block"} ${customClasses?.formBody || ""}`}
      >
        {children ? (
          // Render children if they exist
          children
        ) : (
          // Otherwise render the existing form fields
          <>
            {headerTitle && (
              <label
                className={`block text-sm font-medium text-gray-700 mb-2 ${
                  customClasses?.formSubHeader || ""
                }`}
              >
                {headerTitle}
              </label>
            )}
            <div className={`-mx-2 flex flex-wrap`}>
              {fields.map((item) => (
                <FormRenderer
                  key={item.uniqueField}
                  item={item}
                  fieldValue={values[item.uniqueField]}
                  onFieldChange={onFieldChange}
                  onFieldBlur={onFieldBlur}
                  fieldValues={fieldValues}
                  readOnly={readOnly}
                  currentPiiInfoFields={currentPiiInfoFields}
                  handleFieldLevelHandler={handleFieldLevelHandler}
                  componentContext={componentContext}
                  supplementAddressData={supplementAddressData}
                  customClasses={customClasses}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export { FormContainer };
